import { SopVirtualHblContext } from './sopVirtualHblContext'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey, getSpecificBasicData } from '@/utils/basicDataCache'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import { getUserDefaultDepartment } from '@/api/user'

/**
 * DocumentWorkspace的Context
 */
export class SopVirtualHblWorkspaceContext extends SopVirtualHblContext {
  /**
   * constructor
   */
  constructor(obj) {
    super(obj)
    if (!(obj instanceof SopVirtualHblWorkspaceContext)) {
      this._data.defaultSeaExportJob = null
      this._data.opDepartment = null
      this._data.modifiedData = {} // 在页面中看不到，但被联动修改了的实体数据
      this._data._activeCmpList = [] // 活跃或正在使用中的合作伙伴列表
    }
  }
  get userList() {
    return getCacheListByKey(basicCacheKeys.basic_data_User)
  }
  set userList(userList) {
    // 不可赋值
  }
  get companyList() {
    return getCacheListByKey(basicCacheKeys.basic_data_Company)
  }
  set companyList(companyList) {
    // 不可赋值
  }
  get seaPortList() {
    return getCacheListByKey(basicCacheKeys.basic_data_Seaport)
  }
  set seaPortList(seaPortList) {
    // 不可赋值
  }
  get regionList() {
    return getCacheListByKey(basicCacheKeys.basic_data_Region)
  }
  set regionList(regionList) {
    // 不可赋值
  }
  get paymentTermList() {
    return getCacheListByKey(basicCacheKeys.basic_data_PaymentTerm)
  }
  set paymentTermList(paymentTermList) {
    // 不可赋值
  }
  get packingList() {
    return getCacheListByKey(basicCacheKeys.basic_data_Packing)
  }
  set packingList(packingList) {
    // 不可赋值
  }
  get shippingTermList() {
    return getCacheListByKey(basicCacheKeys.basic_data_ShippingTerm)
  }
  set shippingTermList(shippingTermList) {
    // 不可赋值
  }
  get blModeList() {
    return getCacheListByKey(basicCacheKeys.basic_data_BlMode)
  }
  set blModeList(blModeList) {
    // 不可赋值
  }
  get defaultSeaExportJob() {
    return this._data.defaultSeaExportJob
  }
  set defaultSeaExportJob(defaultSeaExportJob) {
    this._data.defaultSeaExportJob = defaultSeaExportJob
  }
  get opDepartment() {
    return this._data.opDepartment
  }
  set opDepartment(opDepartment) {
    this._data.opDepartment = opDepartment || 0
  }
  get modifiedData() {
    return this._data.modifiedData
  }
  set modifiedData(modifiedData) {
    this._data.modifiedData = modifiedData
  }
  /**
   * 获取实例
   */
  static getInstance() {
    if (!this._instance) {
      this._instance = new SopVirtualHblWorkspaceContext(super.getInstance())
    }
    return this._instance
  }
  /**
   * 准备好数据
   */
  async prepareData() {
    await super.prepareData()
  }
  getCompanyById(cmpIdx) {
    if (!this.companyList) {
      return null
    }
    const activeCmpList = this._data._activeCmpList
    let cmp = activeCmpList.find(p => p.cmpIdx === cmpIdx)
    if (!cmp) {
      cmp = this.companyList.find(p => p.cmpIdx === cmpIdx)
      if (cmp) {
        activeCmpList.push(cmp)
      }
    }
    return cmp
  }
  async getDefaultSeaExportJob() {
    const entityDefValUtil = EntityDefaultValueUtil.getInstance()
    if (!entityDefValUtil.defaultValues) {
      await entityDefValUtil.initEntityDefaultValue()
    }
    this.defaultSeaExportJob = entityDefValUtil.seaExportJob.getData()
  }
  async getOpDepartment(office) {
    if (!this.opDepartment || Number(this.opDepartment.departmentId) <= 0) {
      this.opDepartment = await getUserDefaultDepartment({ category: 'role', shape: 'op', userId: 0, officeId: office.officeId }).then(res => res.data)
    }
  }
}
